var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWizard1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.554 9.7467h-11.869v26.253h-2.5153v-26.231h-14.418v26.231h-2.5153v-26.253h-11.779v-2.5265h11.745v-7.2202h2.5265v7.1753h14.396v-7.1753h2.5265v7.209h11.892c0.0112 0.8534 0.0112 1.6956 0.0112 2.5377z",
    fill: "#6576ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.554 18.337c-0.1347 0.393-0.2246 0.8197-0.4155 1.179-0.6625 1.2913-1.7404 2.0324-3.1778 2.0773-1.864 0.0562-3.728 0.0225-5.6032 0.0225-0.0337 0-0.0786-0.0225-0.1347-0.0337v-9.3088h9.3312v6.0637zm-6.8047 0.7523c1.0892 0 2.1335 0.0337 3.189-0.0112 0.6064-0.0225 1.0667-0.5727 1.1004-1.1903 0.0113-0.2807 0-0.5615 0-0.8422v-2.2121h-4.2894v4.2558z",
    fill: "#6576ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m43.554 4.6936h-9.32v-2.5265h9.32v2.5265z",
    fill: "#6576ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.301 21.627v-9.3312h9.2863c0.0113 0.0786 0.0337 0.1572 0.0337 0.2358 0 1.5159 0.0225 3.0318 0 4.5477-0.0449 2.5041-2.0437 4.5028-4.5477 4.5365-1.5721 0.0224-3.1553 0.0112-4.7723 0.0112zm2.5265-2.5265c0.7636 0 1.4822 0.0112 2.1896 0 1.0106-0.0224 1.8865-0.685 2.01-1.6843 0.1123-0.8534 0.0225-1.7181 0.0225-2.5827h-4.2333c0.0112 1.4261 0.0112 2.8185 0.0112 4.267z",
    fill: "#6576ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m26.621 24.187c0 1.6731 0.0449 3.3238-0.0112 4.9632-0.0786 2.2683-1.9314 4.1884-4.2221 4.3232-1.6731 0.0898-3.3687 0.0224-5.0755 0.0224v-9.2975c3.0992-0.0113 6.1984-0.0113 9.3088-0.0113zm-6.7935 6.7823h0.3481c0.6288 0 1.2576 0.0112 1.8865 0 0.9544-0.0224 1.8191-0.6625 1.9426-1.6057 0.1123-0.8759 0.0224-1.7742 0.0224-2.6613h-4.2108c0.0112 1.4373 0.0112 2.8297 0.0112 4.267z",
    fill: "#6576ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m0.44629 21.627v-9.32h9.2077c0.01123 0.0112 0.03369 0.0337 0.03369 0.0562-0.01123 1.7517 0.10106 3.5146-0.06738 5.2551-0.22457 2.1896-1.8752 3.6943-4.0536 3.975-0.22458 0.0337-0.44916 0.0225-0.67374 0.0225-1.471 0.0112-2.942 0.0112-4.4467 0.0112zm2.5377-6.8047v4.267c0.78603 0 1.5608 0.0561 2.3244-0.0112 0.88709-0.0786 1.5833-0.5952 1.7405-1.471 0.16843-0.8983 0.11229-1.8528 0.1572-2.7736-1.4598-0.0112-2.8297-0.0112-4.2221-0.0112z",
    fill: "#6576ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m9.7551 4.6936h-9.2751v-2.4928h9.2751v2.4928z",
    fill: "#6576ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m17.312 2.1783h9.2863v2.4928h-9.2863v-2.4928z",
    fill: "#6576ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizard1B);
export default __webpack_public_path__ + "static/media/wizard-1b.1bdb38fd12ae3e8504868bb18109667a.svg";
export { ForwardRef as ReactComponent };